import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import searchIcon from '../../assets/images/search-icon.svg';

import './DropdownMultipleSelect.scss';

class DropdownMultipleSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
    this.wrapperRef = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ dropdownOpen: false });
    }
  };

  toggleDropdown = () => {
    this.setState((prev) => ({ dropdownOpen: !prev.dropdownOpen }));
  };

  render() {
    const { selected, available, onAdd, onRemove } = this.props;
    const { dropdownOpen } = this.state;

    return (
      <div className="audience-select-wrapper" ref={this.wrapperRef}>
        <div className="audience-tags-input" onClick={this.toggleDropdown}>
          <img src={searchIcon} alt="search" className="audience-search-icon" />
          {selected.length === 0 ? (
            <span className="audience-placeholder">Please select</span>
          ) : (
            selected.map((item) => (
              <span key={item.id} className="audience-tag">
                {item.label}
                <button
                  type="button"
                  className="audience-tag-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(item.id);
                  }}
                >
                  ×
                </button>
              </span>
            ))
          )}
        </div>
        {dropdownOpen && available.length > 0 && (
          <div className="audience-dropdown">
            {available.map((option) => (
              <div
                key={option.id}
                className="audience-option"
                onClick={() => {
                  onAdd(option.id);
                  this.setState({ dropdownOpen: false });
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

DropdownMultipleSelect.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
  available: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default DropdownMultipleSelect;
